/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { BillingEntityUsageV2 } from './billingEntityUsageV2';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface BillingUsageV2 { 
    cloudProvider?: CloudProviderEnum;
    cloudRegion?: AWSRegionsEnum;
    environment?: string;
    error?: Array<string>;
    orgID?: string;
    reportTime?: string;
    reportingEntityType?: string;
    reportingEntityUsage?: Array<BillingEntityUsageV2>;
    reportingEntityUuid?: string;
    reportingEntityVersion?: string;
    serviceName?: VcdsServiceTypeEnum;
}
export namespace BillingUsageV2 {
}


